import {FC} from 'react';

import Button from '@/shared/components/button';

import RegisterStepsCard from '../RegisterStepsCard';
import {LOGIN_STEPS_CARD} from './consts';

interface StepsSectionProps {
  handleSignInWithEmail: () => void;
}

const StepsSection: FC<StepsSectionProps> = ({handleSignInWithEmail}) => {
  return (
    <section className="flex flex-col items-center gap-8 bg-white px-4 py-14 text-center sm:gap-14 sm:px-12 sm:py-20">
      <div className="flex flex-col gap-4 px-4">
        <h3 className="font-bold text-2xl sm:text-3xl">How it works</h3>
        <p className="font-semibold text-base sm:text-xl">
          Get started on Bumpy today in 3 simple steps:
        </p>
      </div>
      <div className="flex w-full flex-col items-center justify-around gap-8 sm:flex-row sm:items-start">
        {LOGIN_STEPS_CARD.map((card) => (
          <RegisterStepsCard
            key={card.title}
            image={card.image}
            title={card.title}
            description={card.description}
          />
        ))}
      </div>
      <Button
        onClick={handleSignInWithEmail}
        variant="primary"
        size="standard"
        className="w-full max-w-96"
      >
        Try Now
      </Button>
    </section>
  );
};

export default StepsSection;
